import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './AIPathSelect.css';
import { getFirstClassOrgan, getSecondClassOrgan, getCheckItem } from './api';
import { SimpleDialog } from '@ohif/ui/src/components/simpleDialog';

// TODO: Rename to Toggle?
class AIPathSelect extends Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    id: PropTypes.any.isRequired, //设备id -1//请选择
    name: PropTypes.string, //显示名称 默认为''
    device: PropTypes.string, //设备名称'CT'
    value: PropTypes.string,
    inDialog: PropTypes.bool.isRequired, //是否显示
    showDialog: PropTypes.bool,
    styleDialog: PropTypes.object, //样式
    padding: PropTypes.string, //样式
    callbackAICheckPath: PropTypes.func,
    isAll: PropTypes.string,
    appConfig: PropTypes.any,
    getNewAICheckPath: PropTypes.func,
    width: PropTypes.string,
    // onValueChanged: PropTypes.func,
  };

  static defaultProps = {
    name: '未知',
    device: 'CT',
    value: null,
    inDialog: true,
    showDialog: false,
    isAll: 'no',
    styleDialog: {
      background: 'transparent',
      height: 18,
      color: '#fff',
      menuListBackground: '#91B9CD',
      placeholderColor: '#fff',
      padding: '0',
    },
    width: '230px',
  };

  state = {
    loading: false,
    items: [],
    selected: null,
    toggleValue: null,
    isDialogOpen: false,

    dialogStyle: {
      position: 'relative',
      zIndex: '300',
      width: '320px',
      transition: 'all 300ms linear',
    },
  };

  componentDidMount() {
    const fetchClassOrgan = () => {
      try {
        getFirstClassOrgan({
          isAll: this.props.isAll,
          device: this.props.device,
        }).then(response => {
          if (response.status === 'success') {
            response.data = response.data.map(i => {
              let obj = {
                id: i.id,
                label: i.name,
                isParent: true,
                spread: false,
                level: 0,
              };
              return obj;
            });
            this.setState({
              items: response.data,
            });
          }
        });
      } catch (error) {
        console.warn(error);
      }
    };
    if (this.props.device) {
      fetchClassOrgan();
    }
  }

  handleClick(item) {
    const { loading } = this.state;
    // just return when loading
    if (loading) {
      return;
    }

    this.setState({ toggleValue: item }, () => {
      if (item.isParent) {
        if (!item.fetched) {
          this.fetchChildren(item.id);
        } else {
          this.toggleChildren(item.id);
        }
      } else {
        this.setState({ selected: item });
      }
    });
  }
  fetchChildren(pid) {
    const { items } = this.state;
    const itemsCopy = JSON.parse(JSON.stringify(items));
    const parent = itemsCopy.find(obj => obj.id === pid);
    const pidx = itemsCopy.indexOf(parent);

    this.setState({ loading: true }, async () => {
      try {
        if (parent.level === 0) {
          getSecondClassOrgan({
            isAll: this.props.isAll,
            firstOrganId: parent.id,
          }).then(res => {
            if (!res.data.length) return;
            let children1 = res.data.map(i => {
              let obj = {
                id: i.id,
                label: i.name,
                isParent: true,
                spread: false,
                level: 1,
                parentId: parent.id,
              };
              return obj;
            });
            itemsCopy.splice(pidx + 1, 0, ...children1); // insert children
            itemsCopy[pidx].fetched = true; // mark the parent's children has been fetched
            if (!itemsCopy[pidx].spread) {
              itemsCopy[pidx].spread = true; // spread the parent
            }
            this.setState({ items: itemsCopy });
          });
        }
        if (parent.level === 1) {
          getCheckItem({
            isAll: this.props.isAll,
            secondOrganId: parent.id,
          }).then(res => {
            if (!res.data.length) return;
            let children2 = res.data.map(i => {
              let obj = {
                id: i.id,
                label: i.description,
                isParent: false,
                spread: false,
                level: 2,
                parentId: parent.id,
              };
              return obj;
            });
            itemsCopy.splice(pidx + 1, 0, ...children2); // insert children
            itemsCopy[pidx].fetched = true; // mark the parent's children has been fetched
            if (!itemsCopy[pidx].spread) {
              itemsCopy[pidx].spread = true; // spread the parent
            }
            this.setState({ items: itemsCopy });
          });
        }
      } finally {
        this.setState({ loading: false });
      }
    });
  }
  toggleChildren(pid) {
    const { items } = this.state;
    const itemsCopy = JSON.parse(JSON.stringify(items));
    const parent = itemsCopy.find(obj => obj.id === pid);
    const pidx = itemsCopy.indexOf(parent);

    itemsCopy[pidx].spread = !itemsCopy[pidx].spread;
    this.setState({ items: itemsCopy });
  }

  onClose = () => {
    this.setState({
      isDialogOpen: false,
    });
  };

  onConfirm = () => {
    this.props.getNewAICheckPath(this.state.selected.id, this.props.id);
    this.setState({
      isDialogOpen: false,
    });
  };

  render() {
    let { name, inDialog, styleDialog, width, showDialog } = this.props;
    const {
      items,
      selected,
      toggleValue,
      isDialogOpen,
      // dialogStyle,
    } = this.state;

    const onMenuClose = () => {
      if (!showDialog) {
        this.props.callbackAICheckPath(this.state.selected);
        return;
      }
      if (selected && selected.label !== name) {
        this.setState({
          isDialogOpen: true,
        });
      }
    };

    const customStyles = {
      indicatorSeparator: () => null, // removes the "stick"
      placeholder: (provided, state) => ({
        ...provided,
        color: state.children ? styleDialog.placeholderColor : '',
      }),
      menu: base => ({
        ...base,
        backgroundColor: '#556472',
        // zIndex: 9999
      }),
      menuList: base => ({
        ...base,
        paddingTop: '0px',
        color: '#fff',
        backgroundColor: styleDialog.menuListBackground,
        margin: '0px',
      }),
      option: (provided, state) => ({
        ...provided,
        color: '#fff',
        backgroundColor: state.isFocused ? '#91B9CD' : '#556472',
        padding: '12px 20px',
        height: '40px',
      }),
      control: () => ({
        // none of react-select's styles are passed to <Control />
        color: '#fff',
        width: '100%',
        height: styleDialog.height,
        alignItems: 'center',
        display: 'flex',
        backgroundColor: styleDialog.background,
        margin: 0,
        padding: styleDialog.padding,
        borderRadius: 6,
      }),
      singleValue: (styles, { data }) => {
        return {
          ...styles,
          color: styleDialog.color,
        };
      },
      // multiValue: (styles, { data }) => {
      //     return {
      //         ...styles,
      //         color: '#fff',
      //         backgroundColor: '#556472',
      //     };
      // },
      // multiValueLabel: (styles, { data }) => ({
      //     ...styles,
      //     color: '#fff',
      // }),
      // multiValueRemove: (styles, { data }) => ({
      //     ...styles,
      //     color: 'white',
      //     ':hover': {
      //         backgroundColor: 'white',
      //         color: 'white',
      //     },
      // }),
    };

    const isParentSpread = id => {
      const item = items.find(obj => obj.id === id);
      if (item.level === 0) {
        return true;
      }
      if (toggleValue && id === toggleValue.id) {
        return true;
      }
      const parent = items.find(obj => obj.id === item.parentId);
      return parent.spread && isParentSpread(parent.id);
    };

    const CustomOption = ({ data }) => {
      const className = [
        'treeOption',
        toggleValue && toggleValue.id === data.id ? 'treeOptionActive' : '',
        !isParentSpread(data.id) ? 'treeOptionHidden' : '',
      ].join(' ');
      const arrow = data.isParent && (
        <div
          className={['arrow', data.spread ? 'spreadArrow' : ''].join(' ')}
        />
      );
      return (
        <div
          className={className}
          style={{ paddingLeft: `${data.level * 20 + 20}px` }}
          onClick={() => this.handleClick(data)}
        >
          {arrow}
          <p>{data.label}</p>
        </div>
      );
    };

    return (
      <>
        <div
          className="aipath"
          style={{
            width: width,
          }}
        >
          <div className="aipath-left">
            <Select
              styles={customStyles}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder={name ? name : '请选择'}
              // menuShouldBlockScroll={true}
              menuIsOpen={false}
              id="aipath"
              key="aipath"
              options={items}
              isSearchable={false}
              isClearable={false}
              value={selected}
              components={{ Option: CustomOption }}
              menuPlacement="auto"
              menuPortalTarget={
                inDialog
                  ? document.querySelector('.MuiDialog-root')
                  : document.querySelector('body')
              }
              menuPosition={'fixed'}
              onMenuClose={onMenuClose}
            />
          </div>
          {/* <div>
                    +
                </div> */}
        </div>
        <SimpleDialog
          rootClass="aiPathSelect"
          isOpen={isDialogOpen}
          headerTitle="提示"
          onClose={this.onClose}
          onConfirm={this.onConfirm}
        >
          <label className="simpleDialogLabelFor">
            检查项目已发生改变，是否重新执行?
          </label>
        </SimpleDialog>
      </>
    );
  }
}
export default AIPathSelect;
